import Vue from 'vue'
import ElementUI from 'element-ui'

export default function () {
  // 操作成功的提示
  Vue.prototype.$success = (msg = '操作成功！') => {
    ElementUI.Message({
      message: msg,
      type: 'success'
    })
  } 
  // 警告的提示
  Vue.prototype.$waring = (msg = '操作失败！') => {
    ElementUI.Message({
      message: msg,
      type: 'warning'
    })
  }
}



// WEBPACK FOOTER //
// ./src/config/elementSecDev.js